import React from "react";
import { Radar } from "react-chartjs-2";

const RadarChart = ({ data_radar, t }) => {
  const data = {
    labels: [
      t("biodiversity"),
      t("energySobriety"),
      t("economicHealth"),
      t("popularity"),
      t("waterQuality"),
    ],
    datasets: [
      {
        data: [
          data_radar["biodiversity"],
          data_radar["carbon_economy"],
          data_radar["economy"],
          data_radar["popularity"],
          data_radar["water_quality"],
        ],
        backgroundColor: "rgba(32, 86, 115, 0.15)",
        borderColor: "rgba(32, 86, 115, 0.9)",
        borderWidth: 2,
        pointBackgroundColor: "rgba(32, 86, 115, 1)",
        pointBorderColor: "#fff",
        pointBorderWidth: 2,
        pointRadius: 6,
        pointHoverRadius: 9,
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(32, 86, 115, 1)",
        pointHoverBorderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      r: {
        min: 0,
        max: 10,
        angleLines: {
          display: true,
          color: "rgba(32, 86, 115, 0.15)",
          lineWidth: 1,
        },
        grid: {
          color: "rgba(32, 86, 115, 0.12)",
          lineWidth: 1,
        },
        ticks: {
          stepSize: 2,
          color: "rgba(32, 86, 115, 0.5)",
          backdropColor: "transparent",
          font: { size: 11 },
        },
        pointLabels: {
          color: "#205673",
          font: {
            size: 14,
            weight: "600",
          },
        },
      },
    },
    elements: {
      line: {
        borderWidth: 2,
        tension: 0.1,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: false,
    },
  };

  return <Radar data={data} options={options} />;
};

export default RadarChart;
